"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var CartItem_1 = require("./CartItem");
var UpgradeToTwoBottleOneTime_1 = require("./UpgradeToTwoBottleOneTime");
var CartContext_1 = require("./CartContext");
var cart_1 = require("../../utils/cart");
var CartItems = function () {
    var _a = (0, hooks_1.useContext)(CartContext_1.default), cart = _a.cart, upsellModuleVisible = _a.upsellModuleVisible;
    var twoBottleOneTime = (0, cart_1.getTwoBottleOneTime)(cart);
    var isPreggoDuoOneTimeInCart = cart.items.some(function (cartItem) {
        return cartItem.title === 'PREGGO Female & Male Conception Support Bundle - 1 Month Supply';
    });
    var showTwoBottle = upsellModuleVisible && twoBottleOneTime && !isPreggoDuoOneTimeInCart;
    var twoBottleModule = showTwoBottle ? ((0, preact_1.h)(UpgradeToTwoBottleOneTime_1.default, { twoBottleProduct: twoBottleOneTime })) : ((0, preact_1.h)(preact_1.Fragment, null));
    return ((0, preact_1.h)("div", { class: "cart-section__cart-items ".concat(window.sessionStorage.getItem('flashSaleAbV1') == 'true' && 'flashSaleAb') },
        cart.items.map(function (cartItem) { return ((0, preact_1.h)(CartItem_1.default, { item: cartItem, key: cartItem.key })); }),
        twoBottleModule));
};
exports.default = CartItems;
